// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".interview-note-header{color:#7d93b2;font-size:1em}.interview-note .interview-details{margin:0;padding:0;list-style:none}.interview-note .interview-details li{font-size:1rem}.interview-note .interview-details li+li{margin-top:6px}.interview-note .interview-description p{margin-bottom:0;font-size:1rem}.interview-note .interview-description p+p{margin-top:1rem}.interview-note .interview-description ul li{font-size:1rem}\n", ""]);
// Exports
module.exports = exports;
